<template>
  <section class="topsell__area-1 pt-15">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section__head d-flex justify-content-between mb-10">
            <div class="section__title">
              <h5 class="st-titile-d">Top Deals Of The Day</h5>
            </div>
            <div class="offer-time">
              <span class="offer-title d-none d-sm-block">Hurry Up! Offer ends in:</span>
              <div class="countdown">
                <div class="countdown-inner b-radius">
                  <countdown-timer endDate="2025-04-07 20:20:22"></countdown-timer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="product-bs-slider">
          <swiper :pagination="{ el: '.main-slider-paginations', clickable: true }" class="product-slider swiper-container" v-bind="sliderSetting">
            <swiper-slide v-for="product in topProducts" :key="product.id">
              <product-single :product="product"></product-single>
            </swiper-slide>
          </swiper>
          <!-- If we need navigation buttons -->
          <div class="bs-button bs-button-prev"><i class="fas fa-chevron-left"></i></div>
          <div class="bs-button bs-button-next"><i class="fas fa-chevron-right"></i></div>
        </div>
      </div>
    </div> 
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import ProductSingle from '@/components/product/product-single.vue';
import CountdownTimer from '@/components/countdown-timer.vue';

export default {
  name: "TopDeals",
  components: {
    Swiper,
    SwiperSlide,
    ProductSingle,
    CountdownTimer,
  },
  data() {
    return {
      modules: [Navigation],
      topProducts: [],
      nextDate: null, // Holds the calculated next date
      sliderSetting: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.bs-button-next',
          prevEl: '.bs-button-prev',
        },
        breakpoints: {
          550: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
          1400: {
            slidesPerView: 5,
          }
        }
      }
    };
  },
  methods: {
    async fetchDailyDeals() {
      try {
        const response = await this.$axios.get(`/daily-deals-products`);
        this.topProducts = response.data;
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },
    calculateNextDate() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1); // Add 1 day
      const year = tomorrow.getFullYear();
      const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
      const day = String(tomorrow.getDate()).padStart(2, "0");
      const hours = "20";
      const minutes = "20";
      const seconds = "22";

      this.nextDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
  mounted() {
    this.calculateNextDate(); // Set the nextDate value on mount
    this.fetchDailyDeals();
  }
};
</script>

<style scoped>
/* Add any necessary custom styles here */
</style>
